// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"726":"4aebefe7","787":"c07d3996"}[chunkId] + ".chunk.js";
};